// Actions
export const TERMS_OF_SERVICE__ACCEPT = 'TERMS_OF_SERVICE__ACCEPT';
// Mutations
export const TERMS_OF_SERVICE__MUTATE_LOADING_STATUS = 'TERMS_OF_SERVICE__MUTATE_LOADING_STATUS';
export const TERMS_OF_SERVICE__MUTATE_HAS_AGREED = 'TERMS_OF_SERVICE__MUTATE_HAS_AGREED';
